import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { passwordExe } from "../apis/auth";
import { PasswordInfo } from "../types";

const usePasswordUpdate = () => {
    //const dispatch = useAppDispatch();
    return useMutation<AxiosResponse, Error, PasswordInfo>(async (data) => await passwordExe(data), {
        onSuccess: (data) => {
            console.log(data.data);
            // if ("1" === data.data.resultCode) {
            //     dispatch(close());
            //     dispatch(open("password"));
            // } else {
            //     alert("인증 정보가 없습니다. 정보를 확인해 주세요.")
            //     return;
            // }
        }
    });
}

export default usePasswordUpdate;